import {required, email, checkbox} from "./field-rules";

export default [
  {
    name: "allowDataHandling",
    attrs: {
      type: "checkbox",
      label: "Я подтверждаю данные платежа",
      required: true
    },
    rules: [required, checkbox]
  },
  {
    name: "amount",
    attrs: {
      type: "currency",
      label: "Сумма платежа",
      required: true
    },
    rules: [required]
  },
  {
    name: "total",
    attrs: {
      type: "currency",
      label: "Итого к оплате",
      required: true,
      valuesInputDisabled: true
    },
    rules: [ required ]
  },
  {
    name: "email",
    attrs: {
      type: "text",
      label: "Email для отправки чека",
      required: true
    },
    rules: [required, email]
  },

];
